// import config from '../config'
import Vue from 'vue';
import router from '../router/index';
import VueYandexMetrika from 'vue-yandex-metrika'

Vue.use(VueYandexMetrika, {
    id: 71163151,
    router: router,
    env: 'production',
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true
    // other options
});

